import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../layout/headerLanding';
import Footer from '../layout/footerLanding';
import { Helmet } from 'react-helmet';

const Thankyou = () => {
    return (
        <>
            <Helmet>
                <title>Thank You Page</title>
                <meta
                    name="description"
                    content="Vaccination for Shingles at Bridge Health: Herpes Zoster, caused by the varicella-zoster virus. Discover symptoms, Vaccines, treatments, & solutions for effective management."
                />
                <script>
                    {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-TDX5BRK9');`}
                </script>
                
            </Helmet>
            <noscript>
                <iframe
                    src="https://www.googletagmanager.com/ns.html?id=GTM-TDX5BRK9"
                    height="0"
                    width="0"
                    style={{ display: "none", visibility: "hidden" }}
                    title="gtm"
                ></iframe>
            </noscript>
            <Header />
            <section className="internalpage1 thankyou-bg-lg">
                <div className="auto-container">
                    <div className="content-box">
                        <div className="thankyou-lp">
                            <h1 >
                                <span className='thankyou-head-lp'>Thank You — You’re One Step Closer to <span className="highlight1">Better Health.</span></span>
                                <p className='thank-line-lp'>We’ve received your message and will be reaching out shortly. At Bridge Health, your health is our mission, and we’re honored to be part of your care journey.</p>
                            </h1>
                            <img src="/images/new-website/physiotherapy/physiotherapy-lp-new.png" alt="thankyou"
                                className='thankyou-main-img-lg' rel="preload"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Thankyou;
